import request from '@core/services/request';

export const apiTransactionsAPI = {
	richtable: (req: any) => request.post(`/ApiTransactions/richtable`, req),
	get: (id: any) => request.get(`/ApiTransactions/${id}`),
};
